import { render, staticRenderFns } from "./KimsaConfirm.vue?vue&type=template&id=6bf40a4d&scoped=true"
import script from "./KimsaConfirm.vue?vue&type=script&lang=js"
export * from "./KimsaConfirm.vue?vue&type=script&lang=js"
import style0 from "./KimsaConfirm.vue?vue&type=style&index=0&id=6bf40a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf40a4d",
  null
  
)

export default component.exports